import { ApiConfig, Config, Environment } from "../types/api";
import envConfigJson from "./env-config.json";

const ENV_CONFIG = envConfigJson.environments;

const ENV =
  (process.env.REACT_APP_ENVIRONMENT as Environment) || Environment.PRODUCTION;
const isValidEnv = Object.values(Environment).includes(ENV);
const environment = isValidEnv ? ENV : Environment.PRODUCTION;

if (!isValidEnv && process.env.NODE_ENV === "development") {
  console.warn(`Invalid environment "${ENV}". Using ${environment}.`);
}

/**
 * Maps environment configuration to API config
 */
const getApiConfigForEnvironment = (env: Environment): ApiConfig => {
  const envData = ENV_CONFIG[env];
  return {
    baseURL: envData.apiBaseUrl,
    allowedOrigin: envData.eddUrl
  };
};

const CONFIG: Config = {
  environment,
  api: getApiConfigForEnvironment(environment),
  http: {
    timeout: 40000,
    deviceId: "web-user",
    corsMethods: "DELETE, POST, GET, OPTIONS, PATCH",
    corsHeaders: "Content-Type, Authorization, X-Requested-With"
  },
  services: {
    wallet: "wallet-services/",
    backtest: "backtest_services/"
  },
  client: {
    priceClientToken: "528efb3b-582a-4b37-bf38-e4e9718d29a1"
  }
} as const;

export const config = CONFIG as Config;
